import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

export type StateType = 'loading' | 'empty' | 'error';

@Component({
	standalone: true,
	selector: 'app-state-display',
	templateUrl: './state-display.component.html',
	styleUrls: ['./state-display.component.scss'],
	imports: [NgIf, MatProgressSpinnerModule, MatIconModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StateDisplayComponent {
	@Input() type: StateType = 'loading';
	@Input() loadingMessage: string = 'Loading...';
	@Input() emptyMessage: string = 'No data available';
	@Input() errorMessage: string = 'Something went wrong';
	@Input() emptyIcon: string = 'folder_open';
	@Input() errorIcon: string = 'error_outline';
	@Input() customClass: string = '';

	get currentMessage(): string {
		switch (this.type) {
			case 'loading':
				return this.loadingMessage;
			case 'empty':
				return this.emptyMessage;
			case 'error':
				return this.errorMessage;
			default:
				return 'Loading...';
		}
	}

	get currentIcon(): string {
		switch (this.type) {
			case 'empty':
				return this.emptyIcon;
			case 'error':
				return this.errorIcon;
			default:
				return '';
		}
	}

	get containerClass(): string {
		const baseClass = `${this.type}-state`;
		return `${baseClass} ${this.customClass}`.trim();
	}

	get isLoadingState(): boolean {
		return this.type === 'loading';
	}

	get showIcon(): boolean {
		return this.type === 'empty' || this.type === 'error';
	}
}
